import { render, staticRenderFns } from "./SendEgiftPanelMoreOptions.vue?vue&type=template&id=3560ed4e&scoped=true"
import script from "./SendEgiftPanelMoreOptions.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelMoreOptions.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelMoreOptions.vue?vue&type=style&index=0&id=3560ed4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3560ed4e",
  null
  
)

export default component.exports